import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints } from '@rossum/api-client';
import { PatchNotePayload } from '@rossum/api-client/notes';
import { api } from '../../../../lib/apiClient';
import { notify } from '../../../toaster';
import { GET_COMMENTS_QUERY_KEY } from '../../core';

const MUTATION_KEY_UPDATE_COMMENT = 'update-comment';

export const useUpdateComment = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationKey: [MUTATION_KEY_UPDATE_COMMENT] as const,
    mutationFn: ({ id, payload }: { id: number; payload: PatchNotePayload }) =>
      api.request(endpoints.notes.patch(id, payload)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_COMMENTS_QUERY_KEY],
      });
      notify.default({
        title: intl.formatMessage({
          id: 'components.documentComments.toast.updateSuccess',
        }),
      });
    },
    onError: () =>
      notify.error({
        title: intl.formatMessage({
          id: 'components.documentComments.toast.updateError',
        }),
      }),
  });
};
